import { useState, useEffect, Fragment, CSSProperties } from "react";
import {
    StyleSheet, View, Text
} from "react-native";

import { FONT } from "../../../value/staticValues";
import { PLATFORM_URL } from "../../../value/Url";
import { requests } from "../../../common/RestAPI";

import { CustomTextInput, TextArea } from "../../base/CustomInputText";
import { ReactComponent as MsgInfoImg } from '../../../img/ico-msg-info-2.svg';
import { ReactComponent as MoreImg } from '../../../img/ico-prefix-more.svg';
import { ReactComponent as CloseImg } from '../../../img/ico-prefix-close.svg';


import { useTranslation } from "react-i18next";
import { CustomSquareCheckBox } from "../../base/CustomCheckBox";
import { CustomDropDown, DropdownType } from "../../base/CustomDropdown";
import { probeExecTypes } from "./DeploymentData";
import { serviceTypes } from "../service/PodServiceData";
import StepLine from "../../base/tamplate/StepLine";
import { checkUpperString } from "../../../common/util";
import CodeEditor, { SelectionText } from "@uiw/react-textarea-code-editor";
import CustomText from "components/base/CustomText";
import { podVolumeHostPathTypes, podVolumeTypes } from "../profile/PodProfileData";





export interface PodContainer {
    containerName: string;
    containerImageId: string;
    containerImageName: string;
    resourceYn: boolean;
    requestCpuCount: string;
    requestMemoryCapacityMb: string;
    limitsCpuCount: string;
    limitsMemoryCapacityMb: string;
    gpuYn: boolean;
    commands: string;
    volumeMounts: string;
    envs: string;
    ports: string;
    livenessYn: boolean;
    livenessType: string;
    livenessCommands: string;
    livenessHttpGetPath: string;
    livenessHttpGetPort: string;
    livenessHttpGetHeaders: string;
    livenessTcpSocketPort: string;
    livenessInitialDelaySecond: string;
    livenessPeriodSecond: string;
    livenessTimeoutSecond: string;

    readnessYn: boolean;
    readnessType: string;
    readnessCommands: string;
    readnessHttpGetPath: string;
    readnessHttpGetPort: string;
    readnessHttpGetHeaders: string;
    readnessTcpSocketPort: string;
    readnessInitialDelaySecond: string;
    readnessPeriodSecond: string;
    readnessTimeoutSecond: string;

};

export interface PodVolume {
    volumeName: string;
    volumeTypeCode: string;
    claimName: string;
    hostPath: string;
    hostPathTypeCode: string;
    pvcId: string;
}

interface DeploymentAddProps {
    showMessageCb?: Function,
    showLoadingCb?: Function,
    showSlideModalCb?: Function,
    stepIndex: number,
    clickedConfirmYn: boolean,
    resultCb?: Function,
    stepCount: number,
};

DeploymentAdd.defaultProps = {
    stepIndex: 0,
    clickedConfirmYn: false,
    stepCount: 1,
}

export default function DeploymentAdd(props:DeploymentAddProps) {
    const { t } = useTranslation();

    const [stepIndex, setStepIndex] = useState(0);
    const [executeAddYn, setExecuteAddYn] = useState(false);

    const [projectId, setProjectId] = useState("");
    const [podProfileId, setPodProfileId] = useState("");
    const [namespaceId, setNamespaceId] = useState("");
    const [containerClusterId, setContainerClusterId] = useState("");

    const [deploymentName, setDeploymentName] = useState("");
    const [deploymentDesc, setDeploymentDesc] = useState("");
    const [deploymentCount, setDeploymentCount] = useState("");
    const [labels, setLabels] = useState("");
    const [annotations, setAnnotations] = useState("");
    const [selector, setSelector] = useState("");
    const [templateLabels, setTemplateLabels] = useState("");

    const [containers, setContainers] = useState<PodContainer[]>([]);
    const [newContainer, setNewContainer] = useState<PodContainer>({
        containerName: "", containerImageId: "", containerImageName: "", resourceYn: false,
        requestCpuCount: "0", requestMemoryCapacityMb: "0", limitsCpuCount: "0", limitsMemoryCapacityMb: "0",
        gpuYn: false, commands: "", volumeMounts: "", envs: "", ports: "", livenessYn: false, livenessType: "CMD", livenessCommands: "",
        livenessHttpGetPath: "", livenessHttpGetPort: "80", livenessHttpGetHeaders: "", livenessTcpSocketPort: "0", livenessInitialDelaySecond: "30",
        livenessPeriodSecond: "10", livenessTimeoutSecond: "5", readnessYn: false, readnessType: "CMD",  readnessCommands: "", readnessHttpGetPath: "", readnessHttpGetPort: "80",
        readnessHttpGetHeaders: "", readnessTcpSocketPort: "0", readnessInitialDelaySecond: "30",  readnessPeriodSecond: "10", readnessTimeoutSecond: "5"
    });


    const [volumes, setVolumes] = useState<PodVolume[]>([]);
    const [newVolume, setNewVolume] = useState<PodVolume>({
        volumeName:"", volumeTypeCode: "PVC", claimName: "", hostPathTypeCode: "DIR", hostPath: "", pvcId: ""
    })

    const [deploymentYaml, setDeploymentYaml] = useState("");

    const [projectList, setProjectList] = useState<DropdownType[]>([]);
    const [containerImageList, setContainerImageList] = useState<DropdownType[]>([]);
    const [pvcList, setPvcList] = useState<DropdownType[]>([]);
    const [podProfileList, setPodProfileList] = useState<DropdownType[]>([]);
    const [namespaceList, setNamespaceList] = useState<DropdownType[]>([]);
    const [containerClusterList, setContainerClusterList] = useState<DropdownType[]>([]);

    const [deploymentNameWarnYn, setDeploymentNameWarnYn] = useState(false);
    const [deploymentYamlWarnYn, setDeploymentYamlWarnYn] = useState(false);
    const [containerChangeYn, setContainerChangeYn] = useState(false);

    const [newContainerNameWarnYn, setNewContainerNameWarnYn] = useState(false);
    const [newContainerImageNameWarnYn, setNewContainerImageNameWarnYn] = useState(false);

    const [volumeChangeYn, setVolumeChangeYn] = useState(false);
    const [newVolumeNameWarnYn, setNewVolumeNameWarnYn] = useState(false);
    const [newVolumeClaimNameWarnYn, setNewVolumeClaimNameWarnYn] = useState(false);
    const [newVolumeHostPathWarnYn, setNewVolumeHostPathWarnYn] = useState(false);

    const [yamlChangeYn, setYamlChangeYn] = useState(false);

    useEffect(() => {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setStepIndex(props.stepIndex);
    }, [props.stepIndex]);



    useEffect(() => {
        if(props.clickedConfirmYn === true) {
            if(stepIndex < props.stepCount - 1) {
                if(stepIndex === 0) {
                    if(checkDeploymentData()) {
                        executeResult({successYn: true}, false, "");
                    }
                } else if(stepIndex === 1) {
                    if(checkContainerData()) {
                        executeResult({successYn: true}, false, "");
                    }
                } else if(stepIndex === 2) {
                    if(checkVolumeData()) {
                        executeResult({successYn: true}, false, "");
                    }
                }
            } else {
                if(checkYamlData()) {
                    setExecuteAddYn(true);
                }
            }
        }
    }, [props.clickedConfirmYn]);

    useEffect(() => {
        setDeploymentNameWarnYn(false);
        if(stepIndex === 0) {
            if(!projectId) {
                loadProjectList();
            }
        } else if(stepIndex === 1) {
            loadContainerImageList();
        } else if(stepIndex === 2) {
            loadPvcList();
        } else if(stepIndex === 3) {
            loadDeploymentYaml();
        }
    }, [stepIndex]);
    useEffect(() => {
        if(projectId) {
            loadContainerClusterList();
            loadPodProfileList();
        }
    }, [projectId])
    useEffect(() => {
        if(containerClusterId) {
            loadNamespaceList();
        }
    }, [containerClusterId]);
    useEffect(() => {
        if(executeAddYn) {
            executeAddDeployment();
        }
    }, [executeAddYn]);

    useEffect(() => {
        if(containerChangeYn) {
            setContainerChangeYn(false);
        }
    }, [containerChangeYn]);

    useEffect(() => {
        if(volumeChangeYn) {
            setVolumeChangeYn(false);
        }
    }, [volumeChangeYn]);
    useEffect(() => {
        if(yamlChangeYn) {
            setYamlChangeYn(false);
        }
    }, [yamlChangeYn]);

    useEffect(() => {
        if(podProfileId) {
            loadPodProfile();
        }
    }, [podProfileId]);

    function checkDeploymentData() {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }

        setDeploymentNameWarnYn(false);
        let message = "";
        let error = false;
        if(!deploymentName || !projectId || !containerClusterId || !namespaceId || !deploymentCount || Number(deploymentCount) <= 0) {
            message = t("MESSAGE_DEPLOYMENT_INFO_ENTER_ERROR_MESSAGE");
            if(!deploymentName ) {
                setDeploymentNameWarnYn(true);
            }
            error = true;
        }

        if(!checkUpperString(deploymentName)) {
            message = t("MESSAGE_DEPLOYMENT_INFO_ENTER_ERROR_MESSAGE");
            setDeploymentNameWarnYn(true);
            error = true;
        }
        if(error == true) {
            executeResult({}, false, message);
        }

        return !error;

    }

    function checkContainerData() {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }

        let message = "";
        let error = false;
        if(containers.length === 0) {
            message = t("MESSAGE_DEPLOYMENT_CONTAINER_INFO_ENTER_ERROR_MESSAGE");
            error = true;
        }
        for(const container of containers) {
            if(!container.containerImageName){
                message = t("MESSAGE_DEPLOYMENT_CONTAINER_SELECT_IMAGE_ERROR_MESSAGE");
                error = true;
            }
        }
        if(error == true) {
            executeResult({}, false, message);
        }

        return !error;

    }


    function checkVolumeData() {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }

        setNewVolumeNameWarnYn(false);
        setNewVolumeHostPathWarnYn(false);
        let message = "";
        let error = false;
        if(volumes.length > 0) {
            for(const volume of volumes) {
                if(!volume.volumeName) {
                    message = t("MESSAGE_DEPLOYMENT_VOLUME_INFO_ENTER_ERROR_MESSAGE");
                    error = true;
                    setNewVolumeNameWarnYn(true);
                }
                if(volume.volumeTypeCode ==="PVC" && !volume.claimName) {
                    message = t("MESSAGE_DEPLOYMENT_VOLUME_INFO_ENTER_ERROR_MESSAGE");
                    error = true;
                }
                if(volume.volumeTypeCode === "HOSTPATH" && !volume.hostPath) {
                    message = t("MESSAGE_DEPLOYMENT_VOLUME_INFO_ENTER_ERROR_MESSAGE");
                    setNewVolumeHostPathWarnYn(true);
                    error = true;
                }
            }
        }
        if(error == true) {
            executeResult({}, false, message);
        }

        return !error;
    }
    function checkYamlData() {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }

        setDeploymentYamlWarnYn(false);
        let message = "";
        let error = false;
        if(!deploymentYaml) {
            message = t("MESSAGE_DEPLOYMENT_YAML_INFO_ENTER_ERROR_MESSAGE");
            error = true;
            setDeploymentYamlWarnYn(true);
        }
        if(error == true) {
            executeResult({}, false, message);
        }

        return !error;
    }

    function executeResult(result, closeYn, infoMessage) {
        setExecuteAddYn(false);
        if(props.showMessageCb && infoMessage) {
            props.showMessageCb(infoMessage);
        }
        if(props.resultCb) {
            props.resultCb(result, closeYn);
        }
    }

    function makePackgeData() {
        const addPackageData = {
            deployment: {
                deployment_name: deploymentName,
                deployment_description: deploymentDesc,
                deployment_pod_count: Number(deploymentCount),
                labels: labels,
                annotations: annotations,
                selector: selector,
                template_labels: templateLabels,
            },
            pod_containers: containers.map((cont, index) => {
                const data = {
                    pod_container_name: cont.containerName,
                    use_gpu_yn: cont.gpuYn
                };

                data['container_image_name'] = cont.containerImageName;

                if(cont.resourceYn) {
                    data['request_cpu_count'] = Number(cont.requestCpuCount);
                    data['request_memory_capacity_mb'] = Number(cont.requestMemoryCapacityMb);
                    data['limit_cpu_count'] = Number(cont.limitsCpuCount);
                    data['limit_memory_capacity_mb'] = Number(cont.limitsMemoryCapacityMb);
                }
                if(cont.commands) {
                    data['commands'] = cont.commands;
                }
                if(cont.volumeMounts) {
                    data['volume_mounts'] = cont.volumeMounts;
                }
                if(cont.envs) {
                    data['environments'] = cont.envs;
                }
                if(cont.ports) {
                    data['ports'] = cont.ports;
                }

                if(cont.livenessYn) {
                    data['liveness_probe_yn'] = true;
                    if(cont.livenessType === 'CMD') {
                        data['liveness_probe_commands'] = cont.livenessCommands;
                    } else if(cont.livenessType === 'HTTPGET') {
                        data['liveness_probe_http_get_path'] = cont.livenessHttpGetPath;
                        data['liveness_probe_http_get_port'] = cont.livenessHttpGetPort;
                        data['liveness_probe_http_get_headers'] = cont.livenessHttpGetHeaders;
                    } else {
                        data['liveness_probe_tcp_socket_port'] = cont.livenessTcpSocketPort;
                    }
                    data['liveness_probe_init_delay_sec'] = cont.livenessInitialDelaySecond;
                    data['liveness_probe_period_sec'] = cont.livenessPeriodSecond;
                    data['liveness_probe_timeout_sec'] = cont.livenessTimeoutSecond;
                }
                if(cont.readnessYn) {
                    data['readiness_probe_yn'] = true;
                    if(cont.readnessType === 'CMD') {
                        data['readiness_probe_commands'] = cont.readnessCommands;
                    } else if(cont.readnessType === 'HTTPGET') {
                        data['readiness_probe_http_get_path'] = cont.readnessHttpGetPath;
                        data['readiness_probe_http_get_port'] = cont.readnessHttpGetPort;
                        data['readiness_probe_http_get_headers'] = cont.readnessHttpGetHeaders;
                    } else {
                        data['readiness_probe_tcp_socket_port'] = cont.readnessTcpSocketPort;
                    }
                    data['readiness_probe_init_delay_sec'] = cont.readnessInitialDelaySecond;
                    data['readiness_probe_period_sec'] = cont.readnessPeriodSecond;
                    data['readiness_probe_timeout_sec'] = cont.readnessTimeoutSecond;
                }

                return data;
            }),
        };

        if(volumes && volumes.length > 0) {
            addPackageData['pod_volumes'] = volumes.map((volume, index) => {
                const data = {
                    pod_volume_name: volume.volumeName,
                    pod_volume_type_code: volume.volumeTypeCode,
                };
                if(volume.volumeTypeCode === 'PVC') {
                    data['claim_name'] = volume.claimName;
                } else if(volume.volumeTypeCode === "HOSTPATH") {
                    data['host_path'] = volume.hostPath;
                    data['host_path_type_code'] = volume.hostPathTypeCode;
                }
                return data;
            });
        }

        return addPackageData;
    }

    function executeAddDeployment() {
        const body = {
            deployment: {
                deployment_name: deploymentName,
                deployment_description: deploymentDesc,
            },
            namespace: {
                namespace_id: namespaceId
            },
            container_cluster: {
                container_cluster_id: containerClusterId
            },
            deployment_yaml: deploymentYaml
        };

        if(projectId) {
            body['project'] = {};
            body['project']['project_id'] = projectId;
        }

        requests.post(PLATFORM_URL.POD_DEPLOYMENT, body)
        .then((response) => {
            executeResult({successYn: true }, true, "");
        })
        .catch((error) => {
            if(error.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_DEPLOYMENT_ADD_DUPLICATED_ERROR_MESSAGE"));
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
        });
    }

    function loadProjectList() {
        requests.get(PLATFORM_URL.PROJECT, {size: 9999})
        .then((response) => {
            setProjectList(response.data.items.map((v) => {
                return {
                    value: v.project_id,
                    label: v.project_name
                }
            }));
        })
        .catch((error) => {
            if(props.showMessageCb) {
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }

    function loadContainerClusterList() {
        requests.get(PLATFORM_URL.PROJECT + '/' + projectId + PLATFORM_URL.CONTAINER_CLUSETER, {size: 9999})
        .then((response) => {
            setContainerClusterList(response.data.items?.map((data, index) => {
                if(!data.api_server_address) {
                    return false;
                }
                return {
                    value: data.container_cluster_id,
                    label: data.container_cluster_name
                };
            }).filter((v)=>{if(v !== false) return v}));
        })
        .catch((error) => {
            if(props.showMessageCb) {
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }

    function loadNamespaceList() {
        requests.get(PLATFORM_URL.CONTAINER_CLUSETER + '/' + containerClusterId + PLATFORM_URL.POD_NAMESPACE, {size: 9999})
        .then((response) => {
            setNamespaceList(response.data.items?.map((data, index) => {
                return {
                    value: data.namespace_id,
                    label: data.namespace_name
                };
            }).filter((v)=>{if(v !== false) return v}));
        })
        .catch((error) => {
            if(props.showMessageCb) {
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }

    function loadContainerImageList() {
        requests.get(PLATFORM_URL.PROJECT + '/' + projectId + PLATFORM_URL.POD_IMAGE, {size: 9999})
        .then((response) => {
            const containerImages = response.data.items?.map((data, index) => {
                return {
                    value: data.container_image_id,
                    label: data.image_path,
                }
            })

            setContainerImageList([{label: t("DIRECT_INPUT_TEXT"), value:""} ,...containerImages]);
        })
        .catch((error) => {
            if(props.showMessageCb) {
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }


    function loadPvcList() {
        requests.get(PLATFORM_URL.CONTAINER_CLUSETER + '/' + containerClusterId + PLATFORM_URL.POD_PVC, {size: 9999})
        .then((response) => {
            setPvcList(response.data.items?.map((data, index) => {
                if(data.namespace?.namespace_id !== namespaceId){
                    return false;
                }
                return {
                    value: data.persistent_volume_claim_id,
                    label: data.persistent_volume_claim_name,
                }
            }).filter((v)=>{if(v !== false) return v}));
        })
        .catch((error) => {
            if(props.showMessageCb) {
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }

    function loadPodProfileList() {
        requests.get(PLATFORM_URL.PROJECT + '/' + projectId + PLATFORM_URL.POD_PROFILE, {size: 9999, deployment_yn: true})
        .then((response) => {
            const podProfiles = response.data.items?.map((data, index) => {
                if(!data.deployment_yn) {
                    return false;
                }
                return {
                    value: data.pod_profile_id,
                    label: data.pod_profile_name,
                }
            }).filter((v)=>{if(v !== false) return v});

            setPodProfileList([{label: t("DIRECT_INPUT_TEXT"), value:""} ,...podProfiles]);
        })
        .catch((error) => {
            if(props.showMessageCb) {
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }

    function loadDeploymentYaml() {
        const addPackageData = makePackgeData();
        requests.post(PLATFORM_URL.POD_DEPLOYMENT + '/yaml', addPackageData)
        .then((response) => {
            setYamlChangeYn(true);
            setDeploymentYaml(response.data.deployment_yaml);
        })
        .catch((error) => {
            if(props.showMessageCb) {
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }

    function parsePodProfileData(data) {
        setDeploymentCount(data.deployment_pod_count + "");
        setLabels(data.labels);
        setAnnotations(data.annotations);
        setSelector(data.selector);
        setTemplateLabels(data.template_labels);
        setContainers(data.pod_profile_containers.map((container, index) => {
            const newContainer = {};
            newContainer['containerName'] = container.pod_profile_container_name;
            newContainer['containerImageName'] = container.container_image_name;

            if(container.request_cpu_count > 0 || container.request_memory_capacity_mb > 0 || container.limit_cpu_count > 0 || container.limit_memory_capacity_mb > 0 || container.use_gpu_yn) {
                newContainer['resourceYn'] = true;
            } else {
                newContainer['resourceYn'] = false;
            }
            
            newContainer['requestCpuCount'] = container.request_cpu_count.toString();
            newContainer['requestMemoryCapacityMb'] = container.request_memory_capacity_mb.toString();
            newContainer['limitsCpuCount'] = container.limit_cpu_count.toString();
            newContainer['limitsMemoryCapacityMb'] = container.limit_memory_capacity_mb.toString();
            newContainer['gpuYn'] = container.use_gpu_yn;
            
            newContainer['commands'] = container.commands;
            newContainer['volumeMounts'] = container.volume_mounts;
            newContainer['envs'] = container.environments;
            newContainer['ports'] = container.ports;

            newContainer['livenessYn'] = container.liveness_probe_yn;
            newContainer['livenessInitialDelaySecond'] = container.liveness_probe_init_delay_sec.toString();
            newContainer['livenessPeriodSecond'] = container.liveness_probe_period_sec.toString();
            newContainer['livenessTimeoutSecond'] = container.liveness_probe_timeout_sec.toString();
            if(container.liveness_probe_commands) {
                newContainer['livenessType'] = "CMD";
                newContainer['livenessCommands'] = container.liveness_probe_commands;
            } else if(container.liveness_probe_http_get_path && container.liveness_probe_http_get_port > 0){
                newContainer['livenessType'] = "HTTPGET";
                newContainer['livenessHttpGetPath'] = container.liveness_probe_http_get_path;
                newContainer['livenessHttpGetPort'] = container.liveness_probe_http_get_port.toString();
                if(container.liveness_probe_http_get_headers) {
                    newContainer['livenessHttpGetHeaders'] = container.liveness_probe_http_get_headers;
                }
            } else if(container.liveness_probe_tcp_socket_port > 0) {
                newContainer['livenessType'] = "TCPSOCK";
                newContainer['livenessTcpSocketPort'] = container.liveness_probe_tcp_socket_port.toString();
            } else {
                newContainer['livenessYn'] = false;
            }

            newContainer['readnessYn'] = container.readiness_probe_yn;
            newContainer['readnessInitialDelaySecond'] = container.readiness_probe_init_delay_sec.toString();
            newContainer['readnessPeriodSecond'] = container.readiness_probe_period_sec.toString();
            newContainer['readnessTimeoutSecond'] = container.readiness_probe_timeout_sec.toString();
            if(container.readiness_probe_commands) {
                newContainer['readnessType'] = "CMD";
                newContainer['readnessCommands'] = container.readiness_probe_commands;
            } else if(container.readiness_probe_http_get_path && container.readiness_probe_http_get_port > 0){
                newContainer['readnessType'] = "HTTPGET";
                newContainer['readnessHttpGetPath'] = container.readiness_probe_http_get_path;
                newContainer['readnessHttpGetPort'] = container.readiness_probe_http_get_port.toString();
                if(container.readiness_probe_http_get_headers) {
                    newContainer['readnessHttpGetHeaders'] = container.readiness_probe_http_get_headers;
                }
            } else if(container.readiness_probe_tcp_socket_port > 0) {
                newContainer['readnessType'] = "TCPSOCK";
                newContainer['readnessTcpSocketPort'] = container.readiness_probe_tcp_socket_port.toString();
            } else {
                newContainer['readnessYn'] = false;
            }
            return newContainer;
        }));

        setVolumes(data.pod_profile_volumes && data.pod_profile_volumes.length > 0 ? data.pod_profile_volumes.map((volume, index) => {
            const newVolume = {};
            newVolume['volumeName'] = volume.pod_profile_volume_name;
            newVolume['volumeTypeCode'] = volume.pod_profile_volume_type_code;
            newVolume['hostPath'] = volume.host_path;
            newVolume['hostPathTypeCode'] = volume.host_path_type_code;
            newVolume['pvcId'] = "";
            return newVolume;
        }):[]);
    }


    function loadPodProfile() {
        requests.get(PLATFORM_URL.POD_PROFILE + '/' + podProfileId)
        .then((response) => {
            parsePodProfileData(response.data);
        })
        .catch((error) => {
            if(props.showMessageCb) {
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }


    function addContainer() {
        if(props.showMessageCb){
            props.showMessageCb("");
        }
        setNewContainerNameWarnYn(false);
        setNewContainerImageNameWarnYn(false);
        if(!newContainer.containerImageName || !newContainer.containerName) {
            if(!newContainer.containerImageName) {
                setNewContainerImageNameWarnYn(true);
                if(props.showMessageCb){
                    props.showMessageCb(t("MESSAGE_CONTAINER_IMAGE_EMPTY_MESSAGE"));
                }

            }
            if(!newContainer.containerName){
                setNewContainerNameWarnYn(true);
                if(props.showMessageCb){
                    setNewContainerImageNameWarnYn(true);
                    props.showMessageCb(t("MESSAGE_CONTAINER_NAME_EMPTY_MESSAGE"));
                }
            }
            return
        }
        for(const cont of containers) {
            if(cont.containerName === newContainer.containerName) {
                setNewContainerNameWarnYn(true);
                if(props.showMessageCb){
                    props.showMessageCb(t("MESSAGE_CONTAINER_IMAGE_NAME_DUPLICATED_MESSAGE"));
                    return
                }
            }
        }
        setContainers([...containers, newContainer]);
        setNewContainer({
            containerName: "", containerImageId: "", containerImageName: "", resourceYn: false,
            requestCpuCount: "0", requestMemoryCapacityMb: "0", limitsCpuCount: "0", limitsMemoryCapacityMb: "0",
            gpuYn: false, commands: "", volumeMounts: "", envs: "", ports: "", livenessYn: false, livenessType: "CMD", livenessCommands: "",
            livenessHttpGetPath: "", livenessHttpGetPort: "80", livenessHttpGetHeaders: "", livenessTcpSocketPort: "0", livenessInitialDelaySecond: "30",
            livenessPeriodSecond: "10", livenessTimeoutSecond: "5", readnessYn: false, readnessType: "CMD",  readnessCommands: "", readnessHttpGetPath: "", readnessHttpGetPort: "80",
            readnessHttpGetHeaders: "", readnessTcpSocketPort: "0", readnessInitialDelaySecond: "30",  readnessPeriodSecond: "10", readnessTimeoutSecond: "5"
        });
        setContainerChangeYn(true);
    }

    function deleteContainer(container) {
        const tempList = [...containers];

        setContainers(tempList.filter(cont => cont.containerName !== container.containerName));
        setContainerChangeYn(true);
    }

    function selectContainerImage(containerImageId){
        let label = "";
        if(!containerImageId) {
            setNewContainer({...newContainer, containerImageId:""});

        } else {
            for(const containerImage of containerImageList) {
                if(containerImage.value === containerImageId) {
                    label = containerImage.label;
                }
            }
            setNewContainer({...newContainer, containerImageId:containerImageId, containerImageName:label});
        }
    }


    function addVolume() {
        if(props.showMessageCb){
            props.showMessageCb("");
        }
        setNewVolumeNameWarnYn(false);
        setNewVolumeClaimNameWarnYn(false);
        setNewVolumeHostPathWarnYn(false);
        if(!newVolume.volumeName) {
            if(!newVolume.volumeName){
                setNewVolumeNameWarnYn(true);
                if(props.showMessageCb){
                    props.showMessageCb(t("MESSAGE_VOLUME_NAME_EMPTY_MESSAGE"));
                }
            }
            return
        }
        if(newVolume.volumeTypeCode === "PVC" && !newVolume.claimName) {
            setNewVolumeClaimNameWarnYn(true);
            if(props.showMessageCb){
                props.showMessageCb(t("MESSAGE_VOLUME_CLAIM_EMPTY_MESSAGE"));
            }
        }
        if(newVolume.volumeTypeCode === "HOSTPATH" && !newVolume.hostPath) {
            setNewVolumeHostPathWarnYn(true);
            if(props.showMessageCb){
                props.showMessageCb(t("MESSAGE_VOLUME_HOST_PATH_EMPTY_MESSAGE"));
            }
        }
        for(const vol of volumes) {
            if(vol.volumeName === newVolume.volumeName) {
                setNewVolumeClaimNameWarnYn(true);
                if(props.showMessageCb){
                    props.showMessageCb(t("MESSAGE_VOLUME_NAME_DUPLICATED_MESSAGE"));
                    return
                }
            }
            if(newVolume.volumeTypeCode === "PVC") {
                if(vol.claimName === newVolume.claimName) {
                    setNewVolumeClaimNameWarnYn(true);
                    if(props.showMessageCb){
                        props.showMessageCb(t("MESSAGE_VOLUME_CLAIM_DUPLICATED_MESSAGE"));
                        return
                    }
                }
            }
        }

        setVolumes([...volumes, newVolume]);
        setNewVolume({
            volumeName:"", volumeTypeCode: "PVC", claimName: "", hostPathTypeCode: "DIR", hostPath: "", pvcId: ""
        });
        setVolumeChangeYn(true);
    }

    function deleteVolume(volume) {
        const tempList = [...volumes];

        setVolumes(tempList.filter(vol => vol.volumeName !== volume.volumeName));
        setVolumeChangeYn(true);
    }

    function selectPvc(pvcId){
        let label = "";

        if(!pvcId) {
            setNewVolume({...newVolume, pvcId:""});
        } else {
            for(const pvc of pvcList) {
                if(pvc.value === pvcId) {
                    label = pvc.label;
                }
            }
            setNewVolume({...newVolume, pvcId:pvcId, claimName:label});
        }
    }

    function selectPvcForVolume(volume, pvcId){
        const targetList = [...volumes];
        for(let targetVolume of targetList) {
            if(targetVolume.volumeName === volume.volumeName) {
                targetVolume.pvcId = pvcId;
                if(pvcId) {
                    for(const pvc of pvcList) {
                        if(pvc.value === pvcId) {
                            targetVolume.claimName = pvc.label;
                        }
                    }
                }
            }
        }
        setVolumes(targetList);
    }

    function setVolumeClaimName(volume, claimName){
        const targetList = [...volumes];
        for(let targetVolume of targetList) {
            if(targetVolume.volumeName === volume.volumeName) {
                targetVolume.pvcId = "";
                targetVolume.claimName = claimName;
            }
        }
        setVolumes(targetList);
    }


    const stepLabels = [ t("BASE_INFO_INPUT_TEXT"), t("CONTAINER_INFO_INPUT_TEXT"), t("VOLUME_MOUNT_INFO_INPUT_TEXT"), t("DEPLOYMENT_PROFILE_YAML_CHECK_TEXT")];
    return (
        <View style={style.topContainer}>
            <View>
                <StepLine stepIndex={stepIndex} stepCount={props.stepCount} stepLabels={stepLabels}/>
            </View>
            {
                stepIndex === 0 ?
                // 이름, 설명, 사용 유형, 사용 대상
                <View>
                    <View style={{...style.infoBoxContainer, marginTop: 20}}>
                        <MsgInfoImg/>
                        <Text style={style.infoBoxContainerText}>
                            {t("POD_CREATE_INFO_MESSAGE")}
                        </Text>
                    </View>
                    <Text style={style.titleText}>{
                        t("BASE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <CustomText text={t("NAME_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput
                                key={1}
                                width={570} height={36}
                                value={deploymentName}
                                type={"text"}
                                activeYn={true}
                                inputCb={setDeploymentName}
                                warnYn={deploymentNameWarnYn}
                                placeHolderText={t("NAME_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowTopAlignContainer}>
                            <Text style={style.columnText}>
                                {t("DESCRIPTION_TEXT")}
                            </Text>
                            <TextArea
                                key={2}
                                width={570} height={100}
                                value={deploymentDesc}
                                type={"text"}
                                activeYn={true}
                                inputCb={setDeploymentDesc}
                                warnYn={false}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <CustomText text={t("PROJECT_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomDropDown
                                key={6}
                                width={400} height={36}
                                items={projectList}
                                value={projectId}
                                setValue={setProjectId}
                                disable={false}
                                defaultvalue={{label:"", value:""}}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <CustomText text={t("CLUSTER_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomDropDown
                                key={4}
                                width={400} height={36}
                                items={containerClusterList}
                                value={containerClusterId}
                                setValue={setContainerClusterId}
                                disable={projectId ? false: true}
                                defaultvalue={{label:"", value:""}}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <CustomText text={t("NAMESPACE_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomDropDown
                                key={3}
                                width={400} height={36}
                                items={namespaceList}
                                value={namespaceId}
                                setValue={setNamespaceId}
                                disable={containerClusterId ? false : true}
                                defaultvalue={{label:"", value:""}}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("POD_PROFILE_TEXT")}
                            </Text>
                            <CustomDropDown
                                key={5}
                                width={400} height={36}
                                items={podProfileList}
                                value={podProfileId}
                                setValue={setPodProfileId}
                                disable={false}
                                defaultvalue={{label:t("DIRECT_INPUT_TEXT"), value:""}}
                            />
                        </View>
                        
                        <View style={style.rowDivContainer}/>
                    </View>
                    <Text style={style.titleText}>{
                        t("DETAIL_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("Labels")}
                            </Text>
                            <CustomTextInput
                                key={7}
                                width={570} height={36}
                                value={labels}
                                type={"text"}
                                activeYn={containerClusterId && namespaceId ? true : false}
                                inputCb={setLabels}
                                warnYn={false}
                                placeHolderText={t("key=value,key=value,...")}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("Annotations")}
                            </Text>
                            <CustomTextInput
                                key={8}
                                width={570} height={36}
                                value={annotations}
                                type={"text"}
                                activeYn={containerClusterId && namespaceId ? true : false}
                                inputCb={setAnnotations}
                                warnYn={false}
                                placeHolderText={t("key=value,key=value,...")}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("Selector")}
                            </Text>
                            <CustomTextInput
                                key={1121}
                                width={570} height={36}
                                value={selector}
                                type={"text"}
                                activeYn={containerClusterId && namespaceId ? true : false}
                                inputCb={setSelector}
                                warnYn={false}
                                placeHolderText={t("key=value")}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("Template Labels")}
                            </Text>
                            <CustomTextInput
                                key={1122}
                                width={570} height={36}
                                value={templateLabels}
                                type={"text"}
                                activeYn={containerClusterId && namespaceId ? true : false}
                                inputCb={setTemplateLabels}
                                warnYn={false}
                                placeHolderText={t("key=value,key=value,...")}
                            />
                        </View>
                        <View style={{...style.AddInfoBox, marginTop: 0, marginLeft: 145, height: 80}}>
                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16}}>
                                <Text style={style.AddInfoColumnText}>
                                    {t("DEPLOYMENT_COUNT_TEXT")}
                                    <Text style={style.requireText}>
                                        *
                                    </Text>
                                </Text>
                                <CustomTextInput
                                    key={9112}
                                    width={100} height={33}
                                    value={deploymentCount + ""}
                                    type={"number"}
                                    activeYn={containerClusterId && namespaceId ? true : false}
                                    inputCb={setDeploymentCount}
                                    warnYn={false}
                                />
                            </View>
                        </View>
                    </View>
                </View>
                : stepIndex === 1 ?
                <View>
                    <Text style={style.titleText}>{
                        t("CONTAINER_LIST_TEXT")}
                    </Text>
                    {
                        containerChangeYn === false ?
                        containers.map((container, index)=>{
                            return (
                    <View key={index * 1000} style={style.listMainContainer}>
                        <div
                            style={{
                                display: "flex", alignItems: "center", justifyContent: "center",
                                width: 65, height: 24,
                                marginLeft: "auto",
                                borderRadius: 2, borderStyle: "solid", borderWidth: 1, borderColor: "#d4d0db",
                                backgroundColor: "#fff",
                                fontFamily: FONT.REGULAR,
                                fontSize: 12,
                                color: "#333",
                                cursor: "pointer",
                            }}
                            onClick={() => {deleteContainer(container)}}
                        >
                            {t("DELETE_TEXT")}
                            <CloseImg style={{marginLeft: 3}}/>
                        </div>
                        <View style={style.mainContainer}>
                            <View style={style.rowContainer}>
                                <Text style={style.columnText}>
                                    {t("CONTAINER_NAME_TEXT")}
                                </Text>
                                <CustomTextInput
                                    key={101}
                                    width={570} height={36}
                                    value={container.containerName}
                                    type={"text"}
                                    activeYn={false}
                                    inputCb={(v)=>{}}
                                    warnYn={false}
                                    placeHolderText={t("NAME_ENTER_MESSAGE")}
                                />
                            </View>
                            <View style={style.rowContainer}>
                                <Text style={style.columnText}>
                                    {t("IMAGE_NAME_TEXT")}
                                </Text>
                                <CustomTextInput
                                    key={102}
                                    width={570} height={36}
                                    value={container.containerImageName}
                                    type={"text"}
                                    activeYn={false}
                                    inputCb={(v)=>{}}
                                    warnYn={false}
                                    placeHolderText={t("NAME_ENTER_MESSAGE")}
                                />
                            </View>
                            {
                                container.volumeMounts ?
                            <View style={style.rowTopAlignContainer}>
                                <Text style={style.columnText}>
                                    {t("CONTAINER_VOLUME_MOUNT_TEXT")}
                                </Text>
                                <TextArea
                                    key={103}
                                    width={570} height={60}
                                    value={container.volumeMounts}
                                    type={"text"}
                                    activeYn={true}
                                    inputCb={(v)=>{}}
                                    warnYn={false}
                                    placeHolderText={"VOL_NAME_1=MOUNT_PATH_1\nVOL_NAME_2=MOUNT_PATH_2\n..."}
                                />
                            </View>: null
                            }
                        </View>
                    </View>
                            )
                        })
                        :null
                    }
                    {
                        containerChangeYn === false ?
                    <View style={style.listMainContainer}>

                        <View style={style.mainContainer}>
                            <View style={style.rowContainer}>
                                <CustomText text={t("CONTAINER_NAME_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                                <CustomTextInput
                                    key={104}
                                    width={570} height={36}
                                    value={newContainer.containerName}
                                    type={"text"}
                                    activeYn={true}
                                    inputCb={(v)=>{setNewContainer({...newContainer, containerName: v})}}
                                    warnYn={newContainerNameWarnYn}
                                    placeHolderText={t("NAME_ENTER_MESSAGE")}
                                />
                            </View>
                            <View style={style.rowContainer}>
                                <CustomText text={t("CONTAINER_IMAGE_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                                <CustomDropDown
                                    key={105}
                                    width={540} height={36}
                                    items={containerImageList}
                                    value={newContainer.containerImageId}
                                    setValue={(v)=>{selectContainerImage(v)}}
                                    disable={false}
                                    defaultvalue={{label:t("DIRECT_INPUT_TEXT"), value:""}}
                                />
                            </View>
                            <View style={style.rowContainer}>
                                <CustomText text={t("IMAGE_NAME_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                                <CustomTextInput
                                    key={106}
                                    width={570} height={36}
                                    value={newContainer.containerImageName}
                                    type={"text"}
                                    activeYn={true}
                                    inputCb={(v)=>{setNewContainer({...newContainer, containerImageName: v})}}
                                    warnYn={newContainerImageNameWarnYn}
                                    placeHolderText={t("NAME_ENTER_MESSAGE")}
                                />
                            </View>
                            <View style={style.rowContainer}>
                                <Text style={style.columnText}>
                                    {t("RESOURCE_CHECK_TEXT")}
                                </Text>
                                <CustomSquareCheckBox
                                    size={107}
                                    label={t("ACTIVE_TEXT")}
                                    id={"ResourceCheckbox"}
                                    checked={newContainer.resourceYn}
                                    disabled={false}
                                    textStyle={{
                                        fontFamily: FONT.REGULAR,
                                        fontSize: "12px",
                                        color: "#333"
                                    }}
                                    setCheckBoxStatus={(e)=>{setNewContainer({...newContainer, resourceYn: !newContainer.resourceYn})}}
                                />
                            </View>
                            {
                                newContainer.resourceYn ?
                                <View style={{...style.AddInfoBox, marginTop: -10, height: 160, width: 520}}>
                                    <View style={{flexDirection: "row", alignItems: "center"}}>
                                        <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16}}>
                                            <Text style={{...style.AddInfoColumnText, width: 100}}>
                                                {t("REQUEST_CPU_TEXT")}
                                            </Text>
                                            <CustomTextInput
                                                key={108}
                                                width={100} height={33}
                                                value={newContainer.requestCpuCount}
                                                type={"number"}
                                                activeYn={true}
                                                inputCb={(v)=>{setNewContainer({...newContainer, requestCpuCount: v})}}
                                                warnYn={false}
                                            />
                                        </View>
                                        <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16, marginLeft: 35}}>
                                        <Text style={{...style.AddInfoColumnText, width: 100}}>
                                                {t("REQUEST_MEMORY_TEXT")}(Mi)
                                            </Text>
                                            <CustomTextInput
                                                key={109}
                                                width={100} height={33}
                                                value={newContainer.requestMemoryCapacityMb}
                                                type={"text"}
                                                activeYn={true}
                                                inputCb={(v)=>{setNewContainer({...newContainer, requestMemoryCapacityMb: v})}}
                                                warnYn={false}
                                            />
                                        </View>
                                    </View>
                                    <View style={{flexDirection: "row", alignItems: "center"}}>
                                        <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16}}>
                                        <Text style={{...style.AddInfoColumnText, width: 100}}>
                                                {t("LIMIT_CPU_TEXT")}
                                            </Text>
                                            <CustomTextInput
                                                key={110}
                                                width={100} height={33}
                                                value={newContainer.limitsCpuCount}
                                                type={"text"}
                                                activeYn={true}
                                                inputCb={(v)=>{setNewContainer({...newContainer, limitsCpuCount: v})}}
                                                warnYn={false}
                                            />
                                        </View>
                                        <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16, marginLeft: 35}}>
                                        <Text style={{...style.AddInfoColumnText, width: 100}}>
                                                {t("LIMIT_MEMORY_TEXT")}(Mi)
                                            </Text>
                                            <CustomTextInput
                                                key={111}
                                                width={100} height={33}
                                                value={newContainer.limitsMemoryCapacityMb}
                                                type={"text"}
                                                activeYn={true}
                                                inputCb={(v)=>{setNewContainer({...newContainer, limitsMemoryCapacityMb: v})}}
                                                warnYn={false}
                                            />
                                        </View>
                                    </View>
                                    <View style={{flexDirection: "row", alignItems: "center"}}>
                                        <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16}}>
                                        <Text style={{...style.AddInfoColumnText, width: 100}}>
                                                {t("GPU_ACTIVE_TEXT")}
                                            </Text>
                                            <CustomSquareCheckBox
                                                size={112}
                                                label={t("ACTIVE_TEXT")}
                                                id={"ResourceGpuCheckbox"}
                                                checked={newContainer.gpuYn}
                                                disabled={false}
                                                textStyle={{
                                                    fontFamily: FONT.REGULAR,
                                                    fontSize: "12px",
                                                    color: "#333"
                                                }}
                                                setCheckBoxStatus={(e)=>{setNewContainer({...newContainer, gpuYn: !newContainer.gpuYn})}}
                                            />
                                        </View>
                                    </View>
                                </View>
                                :null
                            }
                            <View style={style.rowTopAlignContainer}>
                                <Text style={style.columnText}>
                                    {t("COMMAND_TEXT")}
                                </Text>
                                <CustomTextInput
                                    key={201}
                                    width={570} height={36}
                                    value={newContainer.commands}
                                    type={"text"}
                                    activeYn={true}
                                    inputCb={(v)=>{setNewContainer({...newContainer, commands: v})}}
                                    warnYn={false}
                                    placeHolderText={t("su,-c,echo SampleCommand")}
                                />
                            </View>
                            <View style={style.rowTopAlignContainer}>
                                <Text style={style.columnText}>
                                    {t("ENVIRONMENT_VARIABLE_TEXT")}
                                </Text>
                                <TextArea
                                    key={202}
                                    width={570} height={60}
                                    value={newContainer.envs}
                                    type={"text"}
                                    activeYn={true}
                                    inputCb={(v)=>{setNewContainer({...newContainer, envs: v})}}
                                    warnYn={false}
                                    placeHolderText={"ENV_1=VALUE_1\nENV_2=VALUE_1\n..."}
                                />
                            </View>
                            <View style={style.rowContainer}>
                                <Text style={style.columnText}>
                                    {t("CONTAINER_PORT_TEXT")}
                                </Text>
                                <CustomTextInput
                                    key={203}
                                    width={570} height={36}
                                    value={newContainer.ports}
                                    type={"text"}
                                    activeYn={true}
                                    inputCb={(v)=>{setNewContainer({...newContainer, ports: v})}}
                                    warnYn={false}
                                    placeHolderText={t("80,8080,443,8443...")}
                                />
                            </View>
                            <View style={style.rowTopAlignContainer}>
                                <Text style={style.columnText}>
                                    {t("CONTAINER_VOLUME_MOUNT_TEXT")}
                                </Text>
                                <TextArea
                                    key={204}
                                    width={570} height={60}
                                    value={newContainer.volumeMounts}
                                    type={"text"}
                                    activeYn={true}
                                    inputCb={(v)=>{setNewContainer({...newContainer, volumeMounts: v})}}
                                    warnYn={false}
                                    placeHolderText={"VOL_NAME_1=MOUNT_PATH_1\nVOL_NAME_2=MOUNT_PATH_2\n..."}
                                />
                            </View>
                            <View style={style.rowContainer}>
                                <Text style={style.columnText}>
                                    {t("LivenessProbe")}
                                </Text>
                                <CustomSquareCheckBox
                                    size={205}
                                    label={t("ACTIVE_TEXT")}
                                    id={"LivenessCheckbox"}
                                    checked={newContainer.livenessYn}
                                    disabled={false}
                                    textStyle={{
                                        fontFamily: FONT.REGULAR,
                                        fontSize: "12px",
                                        color: "#333"
                                    }}
                                    setCheckBoxStatus={(e)=>{setNewContainer({...newContainer, livenessYn: !newContainer.livenessYn})}}
                                />
                            </View>
                            {
                                newContainer.livenessYn ?
                                <View style={
                                    newContainer.livenessType === "CMD" ? {...style.AddInfoBox, marginTop: -10, height: 185, width: 520}
                                    : newContainer.livenessType === "HTTPGET" ? {...style.AddInfoBox, marginTop: -10, height: 185, width: 520}
                                    : {...style.AddInfoBox, marginTop: -10, height: 125, width: 520}}>
                                    <View style={{flexDirection: "row", alignItems: "center"}}>
                                        <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16}}>
                                            <Text style={{...style.AddInfoColumnText, width: 100}}>
                                                {t("PROBE_TYPE_TEXT")}
                                            </Text>
                                            <CustomDropDown
                                                key={206}
                                                width={100} height={36}
                                                items={probeExecTypes}
                                                value={newContainer.livenessType}
                                                setValue={(v)=>{setNewContainer({...newContainer, livenessType: v})}}
                                                disable={false}
                                                defaultvalue={{label:"Command", value:"CMD"}}
                                            />
                                        </View>
                                        { newContainer.livenessType === "HTTPGET" || newContainer.livenessType === "TCPSOCK"?
                                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16, marginLeft: 35}}>
                                            <Text style={{...style.AddInfoColumnText, width: 100}}>
                                                    {newContainer.livenessType === "HTTPGET" ? t("HTTP PORT") : t("TCP PORT")}
                                                </Text>
                                                <CustomTextInput
                                                    key={207}
                                                    width={100} height={33}
                                                    value={newContainer.livenessType === "TCPSOCK" ? newContainer.livenessTcpSocketPort : newContainer.livenessHttpGetPort}
                                                    type={"text"}
                                                    activeYn={true}
                                                    inputCb={(v)=>{newContainer.livenessType === "TCPSOCK"? setNewContainer({...newContainer, livenessTcpSocketPort: v}) : setNewContainer({...newContainer, livenessHttpGetPort: v})}}
                                                    warnYn={false}
                                                />
                                            </View>
                                            :null
                                        }
                                    </View>
                                    {
                                        newContainer.livenessType === "HTTPGET"?
                                        <View style={{flexDirection: "row", alignItems: "center"}}>
                                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16}}>
                                            <Text style={{...style.AddInfoColumnText, width: 100}}>
                                                    {t("HTTP_PATH_TEXT")}
                                                </Text>
                                                <CustomTextInput
                                                    key={208}
                                                    width={125} height={33}
                                                    value={newContainer.livenessHttpGetPath}
                                                    type={"text"}
                                                    activeYn={true}
                                                    inputCb={(v)=>{setNewContainer({...newContainer, livenessHttpGetPath: v})}}
                                                    warnYn={false}
                                                />
                                            </View>
                                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16, marginLeft: 35}}>
                                            <Text style={{...style.AddInfoColumnText, width: 100}}>
                                                    {t("HTTP_HEADER_TEXT")}
                                                </Text>
                                                <CustomTextInput
                                                    key={209}
                                                    width={100} height={33}
                                                    value={newContainer.livenessHttpGetHeaders}
                                                    type={"text"}
                                                    activeYn={true}
                                                    inputCb={(v)=>{setNewContainer({...newContainer, livenessHttpGetHeaders: v})}}
                                                    warnYn={false}
                                                    placeHolderText={"key=value,key=value"}
                                                />
                                            </View>
                                        </View>
                                    : newContainer.livenessType === "CMD" ?
                                        <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16}}>
                                        <Text style={{...style.AddInfoColumnText, width: 100}}>
                                                {t("COMMAND_TEXT")}
                                            </Text>
                                            <CustomTextInput
                                                key={210}
                                                width={350} height={36}
                                                value={newContainer.livenessCommands}
                                                type={"text"}
                                                activeYn={true}
                                                inputCb={(v)=>{setNewContainer({...newContainer, livenessCommands: v})}}
                                                warnYn={false}
                                                placeHolderText={t("su,-c,echo SampleCommand")}
                                            />
                                        </View>
                                    : null
                                    }
                                    <View style={{flexDirection: "row", alignItems: "center"}}>
                                        <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16}}>
                                        <Text style={{...style.AddInfoColumnText, width: 100}}>
                                                {t("Initial Delay")}
                                            </Text>
                                            <CustomTextInput
                                                key={211}
                                                width={55} height={33}
                                                value={newContainer.livenessInitialDelaySecond}
                                                type={"text"}
                                                activeYn={true}
                                                inputCb={(v)=>{setNewContainer({...newContainer, livenessInitialDelaySecond: v})}}
                                                warnYn={false}
                                                placeHolderText={"sec"}
                                            />
                                        </View>
                                        <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16, marginLeft: 35}}>
                                        <Text style={{...style.AddInfoColumnText, width: 60}}>
                                                {t("Period")}
                                            </Text>
                                            <CustomTextInput
                                                key={212}
                                                width={50} height={33}
                                                value={newContainer.livenessPeriodSecond}
                                                type={"text"}
                                                activeYn={true}
                                                inputCb={(v)=>{setNewContainer({...newContainer, livenessPeriodSecond: v})}}
                                                warnYn={false}
                                                placeHolderText={"sec"}
                                            />
                                        </View>
                                        <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16, marginLeft: 35}}>
                                        <Text style={{...style.AddInfoColumnText, width: 60}}>
                                                {t("Timeout")}
                                            </Text>
                                            <CustomTextInput
                                                key={213}
                                                width={50} height={33}
                                                value={newContainer.livenessTimeoutSecond}
                                                type={"text"}
                                                activeYn={true}
                                                inputCb={(v)=>{setNewContainer({...newContainer, livenessTimeoutSecond: v})}}
                                                warnYn={false}
                                                placeHolderText={"sec"}
                                            />
                                        </View>
                                    </View>
                                </View>
                                :null
                            }
                            <View style={style.rowContainer}>
                                <Text style={style.columnText}>
                                    {t("ReadinessProbe")}
                                </Text>
                                <CustomSquareCheckBox
                                    size={214}
                                    label={t("ACTIVE_TEXT")}
                                    id={"ReadnessCheckbox"}
                                    checked={newContainer.readnessYn}
                                    disabled={false}
                                    textStyle={{
                                        fontFamily: FONT.REGULAR,
                                        fontSize: "12px",
                                        color: "#333"
                                    }}
                                    setCheckBoxStatus={(e)=>{setNewContainer({...newContainer, readnessYn: !newContainer.readnessYn})}}
                                />
                            </View>
                            {
                                newContainer.readnessYn ?
                                <View style={
                                    newContainer.readnessType === "CMD" ? {...style.AddInfoBox, marginTop: -10, height: 185, width: 520}
                                    : newContainer.readnessType === "HTTPGET" ? {...style.AddInfoBox, marginTop: -10, height: 185, width: 520}
                                    : {...style.AddInfoBox, marginTop: -10, height: 125, width: 520}}>
                                    <View style={{flexDirection: "row", alignItems: "center"}}>
                                        <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16}}>
                                            <Text style={{...style.AddInfoColumnText, width: 100}}>
                                                {t("PROBE_TYPE_TEXT")}
                                            </Text>
                                            <CustomDropDown
                                                key={215}
                                                width={100} height={36}
                                                items={probeExecTypes}
                                                value={newContainer.readnessType}
                                                setValue={(v)=>{setNewContainer({...newContainer, readnessType: v})}}
                                                disable={false}
                                                defaultvalue={{label:"Command", value:"CMD"}}
                                            />
                                        </View>
                                        { newContainer.readnessType === "HTTPGET" || newContainer.readnessType === "TCPSOCK"?
                                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16, marginLeft: 35}}>
                                            <Text style={{...style.AddInfoColumnText, width: 100}}>
                                                    {newContainer.readnessType === "HTTPGET" ? t("HTTP PORT") : t("TCP PORT")}
                                                </Text>
                                                <CustomTextInput
                                                    key={216}
                                                    width={100} height={33}
                                                    value={newContainer.readnessType === "TCPSOCK" ? newContainer.readnessTcpSocketPort : newContainer.readnessHttpGetPort}
                                                    type={"text"}
                                                    activeYn={true}
                                                    inputCb={(v)=>{newContainer.readnessType === "TCPSOCK"? setNewContainer({...newContainer, readnessTcpSocketPort: v}) : setNewContainer({...newContainer, readnessHttpGetPort: v})}}
                                                    warnYn={false}
                                                />
                                            </View>
                                            :null
                                        }
                                    </View>
                                    {
                                        newContainer.readnessType === "HTTPGET"?
                                        <View style={{flexDirection: "row", alignItems: "center"}}>
                                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16}}>
                                            <Text style={{...style.AddInfoColumnText, width: 100}}>
                                                    {t("HTTP_PATH_TEXT")}
                                                </Text>
                                                <CustomTextInput
                                                    key={217}
                                                    width={125} height={33}
                                                    value={newContainer.readnessHttpGetPath}
                                                    type={"text"}
                                                    activeYn={true}
                                                    inputCb={(v)=>{setNewContainer({...newContainer, readnessHttpGetPath: v})}}
                                                    warnYn={false}
                                                />
                                            </View>
                                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16, marginLeft: 35}}>
                                            <Text style={{...style.AddInfoColumnText, width: 100}}>
                                                    {t("HTTP_HEADER_TEXT")}
                                                </Text>
                                                <CustomTextInput
                                                    key={218}
                                                    width={100} height={33}
                                                    value={newContainer.readnessHttpGetHeaders}
                                                    type={"text"}
                                                    activeYn={true}
                                                    inputCb={(v)=>{setNewContainer({...newContainer, readnessHttpGetHeaders: v})}}
                                                    warnYn={false}
                                                    placeHolderText={"key=value,key=value"}
                                                />
                                            </View>
                                        </View>
                                    : newContainer.readnessType === "CMD" ?
                                        <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16}}>
                                        <Text style={{...style.AddInfoColumnText, width: 100}}>
                                                {t("COMMAND_TEXT")}
                                            </Text>
                                            <CustomTextInput
                                                key={219}
                                                width={350} height={36}
                                                value={newContainer.readnessCommands}
                                                type={"text"}
                                                activeYn={true}
                                                inputCb={(v)=>{setNewContainer({...newContainer, readnessCommands: v})}}
                                                warnYn={false}
                                                placeHolderText={t("su,-c,echo SampleCommand")}
                                            />
                                        </View>
                                    : null
                                    }
                                    <View style={{flexDirection: "row", alignItems: "center"}}>
                                        <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16}}>
                                        <Text style={{...style.AddInfoColumnText, width: 100}}>
                                                {t("Initial Delay")}
                                            </Text>
                                            <CustomTextInput
                                                key={220}
                                                width={55} height={33}
                                                value={newContainer.readnessInitialDelaySecond}
                                                type={"text"}
                                                activeYn={true}
                                                inputCb={(v)=>{setNewContainer({...newContainer, readnessInitialDelaySecond: v})}}
                                                warnYn={false}
                                                placeHolderText={"sec"}
                                            />
                                        </View>
                                        <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16, marginLeft: 35}}>
                                        <Text style={{...style.AddInfoColumnText, width: 60}}>
                                                {t("Period")}
                                            </Text>
                                            <CustomTextInput
                                                key={221}
                                                width={50} height={33}
                                                value={newContainer.readnessPeriodSecond}
                                                type={"text"}
                                                activeYn={true}
                                                inputCb={(v)=>{setNewContainer({...newContainer, readnessPeriodSecond: v})}}
                                                warnYn={false}
                                                placeHolderText={"sec"}
                                            />
                                        </View>
                                        <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16, marginLeft: 35}}>
                                        <Text style={{...style.AddInfoColumnText, width: 60}}>
                                                {t("Timeout")}
                                            </Text>
                                            <CustomTextInput
                                                key={222}
                                                width={50} height={33}
                                                value={newContainer.readnessTimeoutSecond}
                                                type={"text"}
                                                activeYn={true}
                                                inputCb={(v)=>{setNewContainer({...newContainer, readnessTimeoutSecond: v})}}
                                                warnYn={false}
                                                placeHolderText={"sec"}
                                            />
                                        </View>
                                    </View>
                                </View>
                                :null
                            }
                        </View>
                        <div
                            style={{
                                display: "flex", alignItems: "center", justifyContent: "center",
                                width: 65, height: 24,
                                marginLeft: "auto",
                                borderRadius: 2, borderStyle: "solid", borderWidth: 1, borderColor: "#d4d0db",
                                backgroundColor: "#fff",
                                fontFamily: FONT.REGULAR,
                                fontSize: 12,
                                color: "#333",
                                cursor: "pointer",
                            }}
                            onClick={() => {addContainer()}}
                        >
                            {t("ADD_TEXT")}
                            <MoreImg style={{marginLeft: 3}}/>
                        </div>
                    </View>
                    :null
                    }
                </View>
                : stepIndex === 2 ?
                <View>
                    <Text style={style.titleText}>{
                        t("VOLUME_LIST_TEXT")}
                    </Text>
                    {
                        volumeChangeYn === false ?
                        volumes.map((volume, index)=>{
                            return (
                    <View key={index * 1000} style={style.listMainContainer}>
                        <div
                            style={{
                                display: "flex", alignItems: "center", justifyContent: "center",
                                width: 65, height: 24,
                                marginLeft: "auto",
                                borderRadius: 2, borderStyle: "solid", borderWidth: 1, borderColor: "#d4d0db",
                                backgroundColor: "#fff",
                                fontFamily: FONT.REGULAR,
                                fontSize: 12,
                                color: "#333",
                                cursor: "pointer",
                            }}
                            onClick={() => {deleteVolume(volume)}}
                        >
                            {t("DELETE_TEXT")}
                            <CloseImg style={{marginLeft: 3}}/>
                        </div>
                        <View style={style.mainContainer}>
                            <View style={style.rowContainer}>
                                <Text style={style.columnText}>
                                    {t("VOLUME_NANE")}
                                </Text>
                                <CustomTextInput
                                    key={301}
                                    width={570} height={36}
                                    value={volume.volumeName}
                                    type={"text"}
                                    activeYn={false}
                                    inputCb={(v)=>{}}
                                    warnYn={false}
                                    placeHolderText={t("NAME_ENTER_MESSAGE")}
                                />
                            </View>
                        </View>
                    </View>
                            )
                        })
                        :null
                    }
                    {
                        volumeChangeYn === false ?
                    <View style={style.listMainContainer}>
                        <View style={style.mainContainer}>
                            <View style={style.rowContainer}>
                                <CustomText text={t("VOLUME_NANE")} fontStyle={style.columnText} asterisk={true}/>
                                <CustomTextInput
                                    key={304}
                                    width={570} height={36}
                                    value={newVolume.volumeName}
                                    type={"text"}
                                    activeYn={true}
                                    inputCb={(v)=>{setNewVolume({...newVolume, volumeName: v})}}
                                    warnYn={newVolumeNameWarnYn}
                                    placeHolderText={t("NAME_ENTER_MESSAGE")}
                                />
                            </View>
                            <Text style={{
                                marginTop: -15, marginLeft: 150, marginBottom: 10,
                                fontFamily: FONT.REGULAR,
                                fontSize: 12,
                                color: "#3a8344",
                            }}>
                                {t("MESSAGE_VOLUME_NAME_MATCHED_VOLUME_MOUNT_NAME_MESSAGE")}
                            </Text>
                            <View style={style.rowContainer}>
                                <CustomText text={t("POD_VOLUME_TYPE_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                                <CustomDropDown
                                    key={459}
                                    width={530} height={36}
                                    items={podVolumeTypes}
                                    value={newVolume.volumeTypeCode}
                                    setValue={(v)=>setNewVolume({...newVolume, volumeTypeCode: v})}
                                    disable={false}
                                    defaultvalue={podVolumeTypes[0]}
                                />
                            </View>
                            {
                                newVolume.volumeTypeCode === "PVC"
                            ?
                            <Fragment><View style={style.rowContainer}>
                                <Text style={style.columnText}>
                                    {t("PVC_SELECT_TEXT")}
                                </Text>
                                    <CustomDropDown
                                        key={305}
                                        width={530} height={36}
                                        items={pvcList}
                                        value={newVolume.pvcId}
                                        setValue={(v)=>{selectPvc(v)}}
                                        disable={false}
                                        defaultvalue={{label:t("DIRECT_INPUT_TEXT"), value:""}}
                                    />
                                </View>
                                <View style={style.rowContainer}>
                                    <CustomText text={t("PV_CLAIM_NAME_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                                    <CustomTextInput
                                        key={306}
                                        width={570} height={36}
                                        value={newVolume.claimName}
                                        type={"text"}
                                        activeYn={true}
                                        inputCb={(v)=>{setNewVolume({...newVolume, claimName: v})}}
                                        warnYn={newVolumeClaimNameWarnYn}
                                        placeHolderText={t("NAME_ENTER_MESSAGE")}
                                    />
                                </View>
                            </Fragment>
                            :newVolume.volumeTypeCode === "HOSTPATH"
                            ?<Fragment>
                                <View style={style.rowContainer}>
                                    <CustomText text={t("POD_VOLUME_HOST_PATH")} fontStyle={style.columnText} asterisk={true}/>
                                    <CustomTextInput
                                        key={5302}
                                        width={570} height={36}
                                        value={newVolume.hostPath}
                                        type={"text"}
                                        activeYn={true}
                                        inputCb={(v)=>{setNewVolume({...newVolume, hostPath: v})}}
                                        warnYn={newVolumeHostPathWarnYn}
                                        placeHolderText={t("HOST_PATH_ENTER_MESSAGE")}
                                    />
                                </View>
                                <View style={style.rowContainer}>
                                    <CustomText text={t("POD_VOLUME_HOST_PATH_TYPE_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                                    <CustomDropDown
                                        key={11349}
                                        width={530} height={36}
                                        items={podVolumeHostPathTypes}
                                        value={newVolume.hostPathTypeCode}
                                        setValue={(v)=>setNewVolume({...newVolume, hostPathTypeCode: v})}
                                        disable={false}
                                        defaultvalue={podVolumeHostPathTypes[0]}
                                    />
                                </View>
                            </Fragment>
                            : null
                            }
                        </View>
                        <div
                            style={{
                                display: "flex", alignItems: "center", justifyContent: "center",
                                width: 65, height: 24,
                                marginLeft: "auto",
                                borderRadius: 2, borderStyle: "solid", borderWidth: 1, borderColor: "#d4d0db",
                                backgroundColor: "#fff",
                                fontFamily: FONT.REGULAR,
                                fontSize: 12,
                                color: "#333",
                                cursor: "pointer",
                            }}
                            onClick={() => {addVolume()}}
                        >
                            {t("ADD_TEXT")}
                            <MoreImg style={{marginLeft: 3}}/>
                        </div>
                    </View>
                    :null
                    }
                </View>
            :stepIndex === 3 ?
            yamlChangeYn === false ?
                <View>
                    <View style={{...style.infoBoxContainer, marginTop: 20}}>
                        <MsgInfoImg/>
                        <Text style={style.infoBoxContainerText}>
                            {t("DEPLOYMENT_CREATE_YAML_INFO_MESSAGE")}
                        </Text>
                    </View>
                    <Text style={style.titleText}>{
                        t("DEPLOYMENT_YAML_DESCRIPTION_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowTopAlignContainer}>
                            <CodeEditor
                                value={deploymentYaml}
                                language="yaml"
                                onChange={(evn) => setDeploymentYaml(evn.target.value)}
                                padding={15}
                                contentEditable={true}
                                style={{
                                    borderRadius: 8,
                                    fontSize: 12,
                                    width: 690,
                                    background: '#fafafa'
                                }}
                            />
                        </View>

                    </View>
                </View>
                : null
            : null
            }
        </View>
    );
}

const style = StyleSheet.create({
    topContainer: {

    },
    listMainContainer: {
        marginTop: 38,
        paddingTop: 20,
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: 20,
        borderRadius: 10,
        borderColor: "#9ea0a5",
        borderWidth: 0.5,
        marginBottom: 20,
    },
    titleText: {
        marginTop: 40,
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        fontWeight: "500",
        color: "#0853fb",
    },
    mainContainer: {
        marginTop: 20
    },
    rowContainer: {
        height: 36,
        flexDirection: "row",
        marginBottom: 30,
        alignItems: "center"
    },
    rowTopAlignContainer: {
        minHeight: 36,
        flexDirection: "row",
        marginBottom: 30,
    },
    rowDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        marginBottom: 30,
    },
    columnText: {
        width: 150,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    infoBoxContainer: {
        flexDirection: "row", alignItems: "center",
        width: 700, height: 40,
        paddingLeft: 10, paddingRight: 10,
        marginBottom: 15,
        borderRadius: 2,
        backgroundColor: "#fafafa"
    },
    infoBoxContainerText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 18,
        color: "#9ea0a5"
    },
    AddInfoBox: {
        width: 580, height: 230,
        marginLeft: 150, marginTop: 20, marginBottom: 20,
        paddingLeft: 20, paddingTop: 20, paddingBottom: 20, paddingRight: 40,
        borderRadius: 10,
        backgroundColor: "#f5f7fa",
    },
    AddInfoColumnText: {
        width: 130,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    requireText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#e86045"
    },
    infoText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#8c8c8c"
    }
});